import React from "react";
import loadingGif from "../images/gif/loading-arrow.gif";
const Loading = () => {
  return (
    <div className="loading">
      <h4>Peering in Process....</h4>
      <img src={loadingGif} alt="" />
    </div>
  );
};

export default Loading;